export const LISTING_MAX_CONTENT_WIDTH = 1120;
export const LISTING_CTA_BOX_WIDTH = 376;
export const LISTING_CTA_BOX_WIDTH_SM = 352;
